import Vue from "vue";
import VueI18n from "vue-i18n";
import enLocale from "./en";
import zhLocale from "./zh";
import hkLocale from "./hk";
import koLocale from "./ko";
import jpLocale from "./jp";

Vue.use(VueI18n);

const messages = {
  en: {
    ...enLocale,
  },
  zh: {
    ...zhLocale,
  },
  hk: {
    ...hkLocale,
  },
  ko: {
    ...koLocale,
  },
  ja: {
    ...jpLocale,
  },
};

// 香港澳门台湾使用繁体

let locale =
  window.LS.get("language") || navigator.language.split("-")[0] || "en";
if (
  navigator.language == "zh-TW" ||
  navigator.language == "zh-HK" ||
  navigator.language == "zh-MO"
) {
  locale = "hk";
}
console.log(locale);
window.LS.set("language", locale);

const i18n = new VueI18n({
  // set locale
  // options: en or zh
  locale,
  // set locale messages
  messages,
});

export default i18n;
